import React, { useState } from 'react';
import Panel from './shared/Panel';
import NftsBalance from './NftsBalance';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Info from './shared/Info';
import Filter from './shared/Filter';

const NftsPanel = (props) => {
	const [ filterText, setfilterText ] = useState('');

	function onSubmitFilter (value) {
		setfilterText(value);
	};

	return (
		<Panel
			title={
				<React.Fragment>
					<Info id="nftsAccount" />
				</React.Fragment>
			}
			toolbar={
				<React.Fragment>
					<Filter onSubmitFilter={onSubmitFilter} />
				</React.Fragment>
			}
		>
      <NftsBalance filterText={filterText}/>
		</Panel>
	);
}

const mapStateToProps = (state, { match: { params: { accountId } } }) => ({
  accountId: accountId
});

export default withRouter(connect(mapStateToProps)(NftsPanel));